export default __webpack_public_path__ + "static/william-86e903d31d5ab582a4ae0a589200961f.webp";